module.exports = __webpack_public_path__ + "static/media/cat-1_2.50798a5b.svg";